import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { ManageShippingAddressesCTA } from "./ctas";

export const ShippingAddressIA: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },

  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => MANAGE_SHIPPING_ADDRESSES(strictLocalize),
    getDescription: () => [
      YOU_ARE_ABLE_TO_MANAGER_YOUR_SHIPPING_ADDRESSES(strictLocalize),
    ],
  };
};

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return ManageShippingAddressesCTA(strictLocalize);
};

const MANAGE_SHIPPING_ADDRESSES = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Manage shipping addresses",
    description: {
      text: "Title for the answer of Shipping address issue",
    },
  });

const YOU_ARE_ABLE_TO_MANAGER_YOUR_SHIPPING_ADDRESSES = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You are able to manage your shipping addresses through your Shipping Addresses tab, which is located under the My Profile tab on the Account Settings page.",
  });
